module.exports = __webpack_public_path__ + "static/media/pizza.8ff66ba8.png";